import { I18n } from '@calendly/i18n'
import { IconExternalLink } from '@calendly/ui/components/glyphs/IconExternalLink'
import { InlineBanner } from '@calendly/ui/components/inline-banner'
import { capitalize } from 'lodash-es'
import { useMemo } from 'react'

import { isPayPalProvider } from './payment_provider_utils'

export const StatusBanner = ({
  provider,
  isStripeConnected,
  isPaypalConnected,
  isPaypalPpcpConnected = false,
}) => {
  let isPaypalUiConnected = false
  if (provider === 'paypal_ppcp' || provider === 'paypal') {
    isPaypalUiConnected = !!isPaypalPpcpConnected
  }

  const statuses = useMemo(() => ({
    stripe: { isConnected: isStripeConnected },
    paypal: { isConnected: isPaypalUiConnected },
  }), [isStripeConnected, isPaypalUiConnected])

  const statusKey = isPayPalProvider(provider) ? 'paypal' : provider
  const status = statuses[statusKey]
  if (!provider || provider === 'none' || !status || status.isConnected) return null

  // PayPal UI lives at /integrations/paypal (PPCP); there is no /integrations/paypal_ppcp route.
  let integrationSlug = 'paypal'
  let actionKey = 'reconnect'
  if (provider === 'stripe') {
    integrationSlug = 'stripe'
  } else if (isPayPalProvider(provider)) {
    actionKey = provider === 'paypal' && isPaypalConnected ? 'upgrade' : 'reconnect'
  }

  const providerLabel = isPayPalProvider(provider) ? 'paypal' : provider
  const reconnectUrl = `/integrations/${integrationSlug}`

  return (
    <InlineBanner
      data-testid="payment-processor-connection-banner"
      variant="danger"
      title={I18n.t('publisher.event_types.payment_method.integration_disconnected_short', {
        provider: capitalize(providerLabel),
      })}
      isDismissible={false}
      primaryButton={{
        label: I18n.t(`publisher.action.${actionKey}`),
        appearance: 'primary',
        trailingIcon: IconExternalLink,
        onClick: () => {
          window.open(reconnectUrl, '_blank', 'noopener,noreferrer')
        },
        responsive: false,
      }}
    />
  )
}
